import React from 'react';
import BlogPost from "../BlogPost";

const FlowerSorcerer = () => {
    return (
        <BlogPost
            id="FlowerSorcerer"
            title="Legend of the Flower Sorcerer"
            content={
                <>
                    &quot;Legend has it that once upon a time a small clan of sorcerers studied their
                    esoteric
                    magic far out of site from society on the eastern coasts of Centrium. A young person
                    among
                    them broke away from their traditional practices and began to take notes, research,
                    and,
                    putting ink to paper, began and, rather quickly, began expanding their clans ancient
                    magic.&quot;
                    <br/><br/>
                    &quot;Rapidly their form surpassed each of their peers, then the adults, elders, and
                    even
                    those of legend from before their time. Taking a nascent wild magic form and
                    reaching
                    the
                    territory of even exceptional druids. They learned to grow plants from barren soil
                    and
                    cull
                    whole forests with a twist of the wrist but no matter how they tried his fellows
                    couldn't
                    comprehend the techniques and form. It wouldn't be long after their tenth birthday
                    that
                    the
                    young person would leave his home behind and begin to wander the land seeking out
                    new
                    means
                    to extend the powers they had acquired.&quot;
                    <br/><br/>
                    &quot;During this journey this scholarly sorcerer would come to discover that
                    certain
                    plants
                    brought them a special excitement. With their vibrant colors, delicate forms,
                    sometimes
                    hidden murderous intent, but above all else simple beautiful for the sake of it.
                    They
                    fell
                    in love with these flowers. Over the years, they would slowly forget the other
                    plants
                    and
                    only think of flowers. Their power, unnoticed by them, sapping the life of all but
                    the
                    awe-inspiring blooms and passing the energy within along to gorgeous blossoms.&quot;
                    <br/><br/>
                    &quot;They would learn to intertwine these plants of choice with themselves. Slowly
                    over
                    time, though no one knows how long it took, each limb, organ, even every hair
                    follicle
                    was
                    replaced with one of their beloved flowers. Somehow unknowingly their humanity had
                    been
                    shed
                    and their form changed. They simply realized one sunrise that they were different.
                    They
                    did
                    not mind or ponder what that difference was. They simply continued wandering looking
                    for
                    the
                    next beautiful flower.&quot;
                    <br/><br/>
                    The old bartender coughs and drops the lofty tone he’d been using as he told his
                    tale. &quot;So the story goes at least&quot; he announces to a rapt audience before
                    continuing &quot;some say they are still out there. A sorcerer made of nothing but
                    flowers
                    that’ll steal your life by just being near.&quot;
                    <br/><br/>
                    Another patron calls out over the crowd with a few drinks behind their voice &quot;I
                    heard
                    they are out there still looking for some special flower&quot; concluding with a
                    snicker. &quot;Indeed,&quot; the bartender retorts. &quot;That’s one version.
                    Another is
                    they lost their soul and are now just a wandering plant. Others say they are still
                    trying to
                    complete the spell their clan had been working on for all those generations. Still
                    another
                    says they are a god of flowers or the variant of that one that they are a
                    counterbalance
                    to
                    some cosmic evil plant.&quot; The last few possibilities blanket the room in
                    silence.
                    Rumors
                    of the destruction of Aldermoure remain unconfirmed but nonetheless word of a giant
                    vine
                    topped by a huge toothed flower have made their way around, even if preposterous and
                    lacking
                    witness testimony.
                    <br/><br/>
                    &quot;Whatever you want to believe. Fact is, I’ve never heard a single first-hand
                    account of
                    this. It’s all from my Greatgrandad or maybe it was my greatgreatgrandma. Point
                    being
                    it’s
                    just an old tale and&quot; he raises his voice before announcing &quot;I’m sure it
                    has
                    nothing to do with these nonsense tales about Aldermoure.&quot;
                    <br/><br/>
                    &quot;They aren’t rumors&quot; a feminine voice quivers. A slender woman sitting in
                    the
                    corner, seemingly uninterested in the stories of the old bartender till now, a drink
                    in
                    front of her, untouched. The bar sits frozen waiting until, after a long pause, she
                    continues.  &quot;I don’t know about this Flower Sorcerer but Aldermoure is in ruin.
                    The
                    monstrous flower is real and the destruction it brought
                    devastating.&quot; Unsteadily,
                    the
                    figure stands, a shadow moving from behind the flagon as she does. Her hands move,
                    blocking
                    view of the movement, and she cups her hands further hiding whatever it might have
                    been
                    from
                    sight. Stumbling at first, she makes her way towards the door and, before stepping
                    outside,
                    she turns back, hands still cupped in front of her, and, facing the room of patrons
                    announces &quot;I only hope this Flower Sorcerer is real because if not the Flower
                    of
                    Madness may be the end of us all.&quot;
                    <br/><br/>
                    They watch her figure pivot and hear the door slam shut behind her but none move as
                    the
                    words sink in. The fear of what might come crawls up their spines like a vine
                    climbing
                    the
                    side of a building. Slowly but surely until it's unable to dislodge. Some that night
                    will
                    drink in an attempt to wash away the woman's words. Others will simply accept the
                    solemn
                    proclamation. Whatever the patrons that evening did the next morning came with the
                    arrival
                    of the first refugees and tales of strange bark-carapace covered monstrosities,
                    vines
                    tipped
                    in sharp barbs slashing at people, and other's with eyes that brought those who
                    looked
                    into
                    them to their knees. The horrors they'd seen were real each retelling the same
                    tales.
                    Some
                    went farther, speaking of the massive toothed flower rising above the church's
                    steeple.
                    While a few of the later arrivals spoke of heroes who faced the monstrosities and,
                    maybe,
                    succeeded in weakening it no one believed the horrors were over.
                    <br/><br/>
                    For those who sat in the pub that evening the woman's words would come back to them
                    time
                    and
                    again. &quot;I only hope this Flower Sorcerer is real.&quot;
                </>
            }
            photoSrc=""
            photoAlt=""
            noteText="I believe the woman, based on my own discussions with a friend present in Aldermoure, may have been one of the heroes who faced the Flower of Madness. Though it's hard to be certain of much other than the sheer distruction Aldermoure has faced. - Datrius Cerid"
        />
    );
};

export default FlowerSorcerer;
